import { Fragment, useCallback, useState } from "react";
import {
  Button,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";

import { AmenityDefinitionEsclusiveReservationSettings } from "../../../graphql/models";
import { i18nForFields } from "../../../i18n";
import { I18NTextField } from "../i18n_text_field";

export type AmenityDefinitionEsclusiveReservationSettingsEditorProps = {
  esclusiveReservationSettings:
    | AmenityDefinitionEsclusiveReservationSettings
    | undefined;
  onChange: (evt: AmenityDefinitionEsclusiveReservationSettings) => void;
};
export function AmenityDefinitionEsclusiveReservationSettingsEditor(
  props: AmenityDefinitionEsclusiveReservationSettingsEditorProps
) {
  const { esclusiveReservationSettings, onChange } = props;

  const [disabled, setDisabled] = useState(true);
  const [enabled, setEnabled] = useState(
    esclusiveReservationSettings?.enabled ?? false
  );

  const [minSlots, setMinSlots] = useState(
    esclusiveReservationSettings?.minConsecutiveSlots ?? 0
  );
  const [maxSlots, setMaxSlots] = useState(
    esclusiveReservationSettings?.maxConsecutiveSlots ?? 0
  );
  const [i18nFields, setI18nFields] = useState<Partial<i18nForFields<"notes">>>(
    esclusiveReservationSettings?.i18n ?? {}
  );

  const toggleEdits = useCallback(() => {
    if (!disabled) {
      onChange({
        enabled,
        maxConsecutiveSlots: maxSlots,
        minConsecutiveSlots: minSlots,
        i18n: i18nFields,
      });
      setDisabled(true);
    } else {
      console.log("setting disabled to false");
      setDisabled(false);
    }
  }, [disabled, enabled, i18nFields, maxSlots, minSlots, onChange]);

  return (
    <Paper elevation={3} style={{ padding: "1rem" }}>
      <Typography variant="h5">
        Impostazioni prenotazioni esclusiva (non valide se "sempre e solo ad uso
        esclusivo")
      </Typography>
      <br />
      <Grid container style={{ width: "100%" }} spacing={4}>
        <Grid item xs={12}>
          <FormGroup>
            <FormControlLabel
              label="Prenotazioni esclusive abilitate?"
              disabled={disabled}
              control={
                <Switch
                  checked={enabled}
                  onChange={() => setEnabled((prev) => !prev)}
                />
              }
            />
          </FormGroup>
        </Grid>
        {enabled && (
          <Fragment>
            <Grid item xs={12} sm={6}>
              <I18NTextField
                disabled={disabled}
                label="Note da mostrare in app"
                type="string"
                variant="outlined"
                value={i18nFields}
                onChange={setI18nFields}
                style={{ width: "100%" }}
                i18nFieldName={"notes"}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled={disabled}
                label="N. minimo di slots consecutivi prenotabili in esclusiva"
                type="number"
                variant="outlined"
                value={minSlots}
                onChange={(evt) => setMinSlots(Number(evt.target.value))}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled={disabled}
                label="N. massimo di slots consecutivi prenotabili in esclusiva"
                type="number"
                variant="outlined"
                value={maxSlots}
                onChange={(evt) => setMaxSlots(Number(evt.target.value))}
                style={{ width: "100%" }}
              />
            </Grid>
          </Fragment>
        )}
        <Grid item xs={12} sm={3}>
          <Button
            onClick={toggleEdits}
            type="button"
            variant="contained"
            color="primary"
          >
            {disabled
              ? "Modifica impostazioni prenotazione esclusiva"
              : "Conferma modifiche prenotazione esclusiva"}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}
